import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const ShowJsonDialog = ({
  open,
  onClose,
  title = 'JSON',
  data,
  maxWidth = 'sm',
}) => {
  const [copied, setCopied] = useState(false);
  const jsonText = data ? JSON.stringify(data, null, 2) : '';

  const handleCopy = async () => {
    if (!jsonText) return;
    try {
      await navigator.clipboard.writeText(jsonText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Box
            component="pre"
            sx={{
              flex: 1,
              backgroundColor: '#f5f5f5',
              p: 2,
              borderRadius: 1,
              overflow: 'auto',
              fontSize: '0.875rem',
              fontFamily: 'monospace',
              maxHeight: '50vh',
              margin: 0,
            }}
          >
            {jsonText || '{}'}
          </Box>
          <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'}>
            <span>
              <IconButton
                size="small"
                onClick={handleCopy}
                disabled={!jsonText}
                aria-label="Copy JSON"
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShowJsonDialog;
